import { useState } from 'react';
import { Loading } from '../../../../components/Loading';

export const ConfirmHorario = ({ onConfirm, onCancel }: { onConfirm: () => void; onCancel: () => void }) => {
    const [loading, setLoading] = useState(false);

    const onClickConfirm = async () => {
        try {
            setLoading(true);
            await onConfirm();
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col gap-2 sm:flex-row-reverse sm:justify-start">
            <button className="btn btn-primary w-full sm:w-auto" onClick={onClickConfirm} disabled={loading}>
                {loading ? <Loading /> : 'Confirmar presença'}
            </button>
            <button className="btn btn-ghost w-full sm:w-auto" onClick={onCancel} disabled={loading}>
                Agora não
            </button>
        </div>
    );
};
